/**
 * 是否为手机等手持设备（与桌面 PC 浏览器区分），用于展示仅移动端需要的交互。
 * 不依赖「手机布局」开关，避免用户在 PC 上切到宫格布局时误出摄像头按钮。
 */
export function isMobileHandsetDevice() {
    if (typeof navigator === "undefined") return false;
    const ua = navigator.userAgent || "";
    if (/Windows NT|Macintosh|X11|Linux x86_64|Win64|WOW64/i.test(ua) && !/Mobile|Android/i.test(ua)) {
        return false;
    }
    return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
}

/** 当前环境是否具备调用 getDisplayMedia 的基础能力（仍需用户授权，且各机型差异大） */
export function supportsGetDisplayMedia() {
    return !!(
        typeof navigator !== "undefined" &&
        navigator.mediaDevices &&
        typeof navigator.mediaDevices.getDisplayMedia === "function"
    );
}
